import React, { useState } from "react";
import { AppLayoutHeader, AppSideNavbar } from "../../components";
import AppAlert from "../../components/_shared/AppAlert";
import { APP_CONFIGS, LAYOUT_CONFIGS } from "../../_constants";
import { useDispatch, useSelector } from "react-redux";
import { authorizationService } from "../../_services";
import { IPublicClientApplication } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import styles from './AppLayout.module.scss'
import { sideNavActions } from "../../_redux/actions";

const handleLogout = (instance: IPublicClientApplication) => {
    localStorage.removeItem('StyleManagementFilter')
    instance.logoutRedirect().catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e)
    })
}

const AppLayout = (props) => {
    const DRAWER_WIDTH = LAYOUT_CONFIGS.DRAWER_COLLAPSED_WIDTH
    const user = authorizationService.getAuthorizedUser();
    const dispatch = useDispatch()
    const { instance } = useMsal()

    const [drawerWidth, setDrawerWidth] = useState(DRAWER_WIDTH)
    const sidenavStatus = useSelector((state: any) => state.sidenav)

    React.useEffect(() => {
        const DRAWER_WIDTH = sidenavStatus ? LAYOUT_CONFIGS.DRAWER_OPENED_WIDTH : LAYOUT_CONFIGS.DRAWER_COLLAPSED_WIDTH
        setDrawerWidth(DRAWER_WIDTH)
    }, [sidenavStatus])

    const toggleDrawer = (status: boolean) => {
        dispatch(sideNavActions.toggleNav(status))
    }

    const signOut = () => {
        sessionStorage.removeItem(APP_CONFIGS.USER_SESSION_KEY);
        localStorage.removeItem(APP_CONFIGS.USER_FACTORIES_SESSION_KEY);
        handleLogout(instance);
    }

    return (

        <div className={styles.root}>
            <AppLayoutHeader
                drawerStatus={sidenavStatus}
                drawerWidth={drawerWidth}
                userInfo={user}
                onSignOut={signOut}
            />
            <AppSideNavbar drawerStatus={sidenavStatus} drawerWidth={drawerWidth} toggleDrawer={toggleDrawer} />
            <main className={styles.content} style={{ marginLeft: drawerWidth }}>
                <AppAlert />
                {props.children}
            </main>
        </div>
    )
}

export default AppLayout;
